export default "__VITE_ASSET__CtWdzaZ$__"